module.exports = __webpack_public_path__ + "img/chbucket.8180577d.svg";